(function () {
  if (window.__wouuSubscriptionCtaInitialized) return;
  window.__wouuSubscriptionCtaInitialized = true;

  var TEXT_EMPTY = 'Descubrir suscripción';
  var TEXT_LOGGED = 'Iniciar suscripción';
  var TEXT_GUEST = 'Crear cuenta o Iniciar Sesión';
  var EMPTY_HREF = '/collections/suscripcion';
  var HASH = '#iniciar-suscripcion';
  var FLAG_KEY = 'wouu_sub_open_after_reload';

  function setText(element, text) {
    var span = element.querySelector('[slot="signed-out-avatar"]');
    if (span) {
      span.textContent = text;
    } else {
      element.textContent = text;
    }
  }

  function updateButton(element, itemCount) {
    var isLoggedIn = element.dataset.customerLoggedIn === 'true';
    if (isLoggedIn) {
      if (itemCount === 0) {
        setText(element, TEXT_EMPTY);
        element.setAttribute('href', EMPTY_HREF);
        element.removeAttribute('data-subscription-trigger');
      } else {
        setText(element, TEXT_LOGGED);
        element.setAttribute('href', '#');
        element.setAttribute('data-subscription-trigger', '');
      }
    } else {
      if (itemCount === 0) {
        setText(element, TEXT_EMPTY);
        element.setAttribute('data-cta-empty-cart', '');
      } else {
        setText(element, TEXT_GUEST);
        element.removeAttribute('data-cta-empty-cart');
      }
    }
  }

  // Lo que manda no es cuántos items tiene el carrito sino cuántos se pueden suscribir:
  // los packs (bundles) y los regalos de compra única no cuentan. La regla vive en
  // Cart.isSubscribableItem (innovate.js), que carga antes que este archivo.
  function subscribableCount(cart) {
    if (window.Cart && typeof window.Cart.getSubscribableItemCount === 'function') {
      return window.Cart.getSubscribableItemCount(cart);
    }
    // Sin innovate.js no podemos aplicar la regla: mejor dejar todo como estaba que
    // esconder botones por un falso 0.
    return cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
  }

  // Los botones que abren la suscripción desde el carrito (drawer y página de carrito)
  // se esconden cuando no hay nada suscribible: con el carrito solo con packs y/o
  // regalos no hay suscripción posible. El markup los marca con
  // data-subscription-cart-trigger. Va por JS porque el theme solo re-renderiza
  // api-cart-items y api-cart-subtotal: el footer del drawer se pinta una sola vez y
  // quedaría desactualizado cuando el carrito cambia por AJAX.
  function updateCartTriggers(count) {
    document.querySelectorAll('[data-subscription-cart-trigger]').forEach(function (trigger) {
      var target = trigger.closest('.drawer__footer__subscription') || trigger;
      target.style.display = count === 0 ? 'none' : '';
    });
  }

  function updateAll(cart) {
    var count = subscribableCount(cart);
    document.querySelectorAll('[data-subscription-cta]').forEach(function (btn) {
      updateButton(btn, count);
    });
    updateCartTriggers(count);
  }

  function refreshFromServer() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(updateAll);
  }

  function attachShopifyAccountHandler(sa) {
    if (sa._wouuCtaBound) return;
    sa._wouuCtaBound = true;
    sa.addEventListener('click', function (e) {
      if (sa.hasAttribute('data-cta-empty-cart')) return;
      sessionStorage.setItem(FLAG_KEY, '1');
      if (!location.hash.includes('iniciar-suscripcion')) {
        history.replaceState(null, '', location.pathname + location.search + HASH);
      }
      e.stopPropagation();
    });
  }

  function bindShopifyAccountCtas() {
    document.querySelectorAll('shopify-account[data-subscription-cta]').forEach(attachShopifyAccountHandler);
  }

  // Ignoramos a propósito el carrito que viaja en el evento y releemos /cart.js: es el
  // único endpoint que devuelve has_components. Las respuestas de /cart/add.js y
  // /cart/change.js no traen ese campo, y theme.js emite theme:cart:change justo con la
  // respuesta de change.js (fireChange). Con ese payload un pack se ve igual que un
  // producto simple y el botón quedaba visible al borrar del carrito los productos que
  // sí se pueden suscribir. El debounce evita duplicar el fetch cuando theme.js y
  // window.Cart.updateCart() disparan el evento casi al mismo tiempo.
  var refreshTimer = null;
  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshFromServer, 50);
  }

  document.addEventListener('theme:cart:change', scheduleRefresh);
  document.addEventListener('theme:cart:init', scheduleRefresh);
  document.addEventListener('theme:cart:reload', scheduleRefresh);

  document.addEventListener('click', function (e) {
    var cta = e.target.closest('[data-subscription-cta]');
    if (!cta) return;

    if (cta.tagName === 'SHOPIFY-ACCOUNT' && cta.hasAttribute('data-cta-empty-cart')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = EMPTY_HREF;
      return;
    }

    if (cta.tagName === 'A' && cta.getAttribute('href') === '#') {
      e.preventDefault();
    }
  }, true);

  function init() {
    bindShopifyAccountCtas();
    refreshFromServer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
